import styled from '@emotion/styled'

/* Hack to open menu on Lumen's search filter button trigger */
/* Basically, an invisible anchor element placed on search bar */
export const TransactionsSearchFilterMenuAnchor = styled.span`
  position: absolute;
  inset: 0;
  pointer-events: none;
`

/* Some Lumen related customisations for the clear button which should not clear the menu */
export const TransactionsSearchFilterMenuClearButton = styled.span`
  display: block;

  > button {
    justify-content: flex-start;
    width: 100%;
    border-radius: var(--lumen-border-radius-8);
  }
`
